import { connect } from 'react-redux';
import { get } from 'lodash';
import AppDetailPage from '../components/AppDetailPage';
import Tracking from '../lib/fpti';
import dataFetcher from './DataFetcher';
import * as MyAppsActions from '../actions/myapps';
import * as TrackingActions from '../actions/tracking';

const mapStateToProps = state => {
  return {
    app: get(state, 'app', {}),
    tracking: Tracking,
    experimentation: get(state, 'experimentation', {}),
    partner: get(state, 'myapps.path', ''),
    tools: get(state, 'myapps.tools', {}),
    user: get(state, 'user', {})
  };
};

const mapDispatchToProps = dispatch => ({
  ...MyAppsActions,
  ...TrackingActions,
  dispatch
});

const Wrapper = dataFetcher(AppDetailPage, [MyAppsActions.fetchTools]);
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
